import React, { useEffect, useState } from "react";
import './App.css';
import SplashScreen from "./SplashScreen";
import PasswordGenerator from './Components/PasswordGenerator';
import 'react-toastify/dist/ReactToastify.css';


function App() {

  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    // Simulate an app loading delay
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2000); // Adjust the time as needed

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`App ${showSplash ? 'hide-app' : ''}`}>
    {showSplash ? (
    <SplashScreen />
     ) : ( <div>
    <PasswordGenerator />
    </div>
           )}
           </div>
  );
}

export default App;
